angular.module('impactx.cscontract').controller('CSContractBasicListForLotCtrl', [
    '$scope',
    '$redirect',
    '$controller',
    '$routeParams',
    'PartialDialogsService',
    CSContractBasicListForLotCtrl]);

function CSContractBasicListForLotCtrl($scope, $redirect, $controller, $routeParams, PartialDialogsService) {
    var mainCtrl = $controller('CSContractListCtrl', {});
    PartialDialogsService.setCurrentList(PartialDialogsService.TYPE.CONTRACT, 'cscontractlist/lot/'+($routeParams.lotId ? $routeParams.lotId : 0));
    mainCtrl.meta = {
        rowTemplate: 'modules/cscontract/templates/cscontractlist.row.tmpl.html',
        filtersTemplate: 'modules/cscontract/templates/cscontractlist.filters.tmpl.html',
        endpoint: '/cscontract/listforlot',
        ctrl: mainCtrl,
        id: "cscontractlistforlot",
        params: {'lotId': $routeParams.lotId ? $routeParams.lotId : 0},
        buttonDefinition: mainCtrl.buttonDefinition,
        excelParams: {
            params: [{param: 'LotId', intValue: $routeParams.lotId ? $routeParams.lotId : 0},
                {param: 'TenderId', intValue: 0}]
        },
        isSelectAble: true,
        valuesInteger: [{name: "CSC_Id", value: 0}]
    };
    this.getMeta = function () {
        return mainCtrl.meta;
    };
    mainCtrl.contractType = "basic";
    $scope.$watch(function () {
        return mainCtrl.contractType;
    }, function (newValue) {
        if (newValue == "model") {
            $redirect.redirectTo(null, "/cscontractmodellist/lot/" + $routeParams.lotId);
        }
    });
}